import { useEffect, useState } from "react";
import { Maximize2, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export const ModelGallery = ({ model }) => {
  const [active, setActive] = useState(null);
  useEffect(() => {
    if (!active) return undefined;
    const close = (event) => event.key === "Escape" && setActive(null);
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [active]);

  return (
    <>
      <div className="grid gap-4 md:grid-cols-12" data-testid={`${model.slug}-gallery`}>
        {model.gallery.map((image, index) => (
          <button key={image.id} data-testid={`${model.slug}-gallery-${image.id}`} onClick={() => setActive(image)} className={`group relative overflow-hidden bg-cream text-left ${index < 2 ? "md:col-span-6" : "md:col-span-4"}`} aria-label={`Agrandir : ${image.label}`}>
            <div className={index < 2 ? "aspect-[16/10]" : "aspect-[4/3]"}>
              <img src={image.src} alt={image.alt} loading="lazy" className={`h-full w-full object-center transition-transform duration-700 group-hover:scale-[1.03] ${image.fit === "contain" ? "bg-white object-contain p-3" : "object-cover"}`} />
            </div>
            <span className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/65 to-transparent px-4 pb-4 pt-12 text-sm font-semibold text-white"><span>{image.label}</span><Maximize2 className="h-4 w-4" /></span>
          </button>
        ))}
      </div>
      <AnimatePresence>
        {active && <motion.div data-testid={`${model.slug}-lightbox`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setActive(null)} className="fixed inset-0 z-[80] flex items-center justify-center bg-[#18201B]/95 p-4 sm:p-8">
          <button data-testid={`${model.slug}-lightbox-close`} onClick={() => setActive(null)} aria-label="Fermer la photo" className="absolute right-4 top-4 z-10 bg-white/10 p-3 text-white transition-colors hover:bg-white/20"><X className="h-5 w-5" /></button>
          <motion.img initial={{ scale: 0.97 }} animate={{ scale: 1 }} src={active.src} alt={active.alt} onClick={(event) => event.stopPropagation()} className="max-h-[88vh] max-w-full object-contain" />
        </motion.div>}
      </AnimatePresence>
    </>
  );
};